<template>
  <div class="address-edit-input">
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group
        v-if="!noName"
        :id="'address-edit-input-name-label-' + _uid"
        label="Address Name"
        description="Please name this address something meaningful eg. 'Home' or 'Work'. This is will not show on your order."
        :label-for="'address-edit-input-name-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-name-input-' + _uid"
          name="Name"
          v-model="$v.form.Name.$model"
          :state="validateState('Name')"
          :aria-describedby="'address-edit-input-name-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-name-feedback-' + _uid"
        >
          This is a required field, and must be unique.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-recipient-label-' + _uid"
        label="Recipient"
        v-if="!noRecipient"
        :label-for="'address-edit-input-recipient-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-recipient-input-' + _uid"
          name="Recipient"
          v-model="$v.form.Recipient.$model"
          :state="validateState('Recipient')"
          :aria-describedby="'address-edit-input-recipient-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-recipient-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-address1-label-' + _uid"
        label="Address"
        :label-for="'address-edit-input-address1-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-address1-input-' + _uid"
          name="Address1"
          v-model="$v.form.Address1.$model"
          :state="validateState('Address1')"
          :aria-describedby="'address-edit-input-address1-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-address1-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-address2-label-' + _uid"
        label=""
        :label-for="'address-edit-input-address2-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-address2-input-' + _uid"
          name="Address2"
          v-model="$v.form.Address2.$model"
          :state="validateState('Address2')"
          :aria-describedby="'address-edit-input-address2-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-address2-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-address3-label-' + _uid"
        label=""
        :label-for="'address-edit-input-address3-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-address3-input-' + _uid"
          name="Address3"
          v-model="$v.form.Address3.$model"
          :state="validateState('Address3')"
          :aria-describedby="'address-edit-input-address3-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-address3-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-city-label-' + _uid"
        label="City"
        :label-for="'address-edit-input-city-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-city-input-' + _uid"
          name="City"
          v-model="$v.form.City.$model"
          :state="validateState('City')"
          :aria-describedby="'address-edit-input-city-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-city-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-country-label-' + _uid"
        label="Country"
        :label-for="'address-edit-input-country-input-' + _uid"
      >
        <b-form-select
          :id="'address-edit-input-country-input-' + _uid"
          name="Country"
          :options="countries"
          v-model="$v.form.Country.$model"
          :state="validateState('Country')"
          :aria-describedby="'address-edit-input-country-feedback-' + _uid"
        ></b-form-select>

        <b-form-invalid-feedback
          :id="'address-edit-input-country-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-postcode-label-' + _uid"
        label="Postcode"
        :label-for="'address-edit-input-postcode-input-' + _uid"
      >
        <b-input-group>
          <b-form-input
            :id="'address-edit-input-postcode-input-' + _uid"
            name="PostCode"
            v-model="$v.form.PostCode.$model"
            :state="validateState('PostCode')"
            :aria-describedby="'address-edit-input-postcode-feedback-' + _uid"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="secondary" @click="lookupPostcode"
              >Find Address</b-button
            >
          </b-input-group-append>
        </b-input-group>

        <b-form-invalid-feedback
          :id="'address-edit-input-postcode-feedback-' + _uid"
        >
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :id="'address-edit-input-telephone-label-' + _uid"
        label="Telephone"
        v-if="!noTelephone"
        :label-for="'address-edit-input-telephone-input-' + _uid"
      >
        <b-form-input
          :id="'address-edit-input-telephone-input-' + _uid"
          name="Telephone"
          v-model="$v.form.Telephone.$model"
          :state="validateState('Telephone')"
          :aria-describedby="'address-edit-input-telephone-feedback-' + _uid"
        ></b-form-input>

        <b-form-invalid-feedback
          :id="'address-edit-input-telephone-feedback-' + _uid"
        >
          Please enter a valid telephone number
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>

    <address-lookup
      ref="address-lookup"
      :postcode="$v.form.PostCode.$model"
      @input="setResolvedAddress"
    ></address-lookup>
  </div>
</template>

<script>
import AddressLookup from "@/components/AddressLookup";
import { getNameList } from "country-list";
import { map } from "lodash-es";
import Inflector from "inflector-js";

import { required, minLength } from "vuelidate/lib/validators";

import Vue from "vue";
import { FormPlugin } from "bootstrap-vue";

Vue.use(FormPlugin);

export default {
  components: {
    AddressLookup,
  },
  props: {
    noName: {
      type: Boolean,
      default: false,
    },
    noRecipient: {
      type: Boolean,
      default: false,
    },
    noTelephone: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    addressType: {
      type: String,
      default: "Customer",
    },
    value: {
      type: [Boolean, Object],
      default: () => {
        return {
          Name: "",
          Recipient: "",
          Address1: "",
          Address2: "",
          Address3: "",
          City: "",
          Country: "GB",
          PostCode: "",
          Telephone: "",
        };
      },
    },
  },
  validations() {
    var rules = {
      form: {
        Address1: {
          required,
        },
        Address2: {},
        Address3: {},
        City: {
          required,
        },
        Country: {
          required,
        },
        PostCode: {
          required,
        },
      },
    };

    if (!this.noRecipient) {
      rules.form.Recipient = {
        required,
      };
    }

    if (!this.noTelephone) {
      rules.form.Telephone = {
        required,
        minLength: minLength(6),
      };
    }

    if (!this.noName) {
      rules.form.Name = {
        required,
        isUnique(value) {
          for (var i in this.$store.state.user.address_book[this.addressType]) {
            if (
              this.$store.state.user.address_book[this.addressType][i].Name ===
              value
            ) {
              return false;
            }
          }

          return true;
        },
      };
    }

    return rules;
  },
  computed: {
    countries() {
      return map(getNameList(), (v, k) => {
        return { text: Inflector.camel2words(k), value: v.toUpperCase() };
      });
    },
  },
  methods: {
    lookupPostcode() {
      this.$refs["address-lookup"].lookup();
    },
    emitValidity(noEmitInput) {
      if (this.$v.$invalid) {
        this.$emit("valid", false);
      } else {
        this.$emit("valid", true);
        if (!noEmitInput) {
          this.$emit("input", this.form);
        }
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      this.emitValidity();
      return $dirty ? !$error : null;
    },
    setResolvedAddress(addr) {
      const old = { ...this.form };
      this.form = { ...addr };

      this.form.Recipient = old.Recipient;
      this.form.Name = old.Name;

      // if (!this.noTelephone) {
      this.form.Telephone = old.Telephone;
      // }
    },
  },
  mounted() {
    this.form = { ...this.value };
    this.$v.$touch();

    this.emitValidity();
  },
  watch: {
    value(val) {
      this.form = { ...val };

      this.emitValidity(true);
    },
  },
  data() {
    return {
      form: {},
    };
  },
};
</script>